import { useAlert } from 'dashboard/composables';
import DashboardAudioNotificationHelper from './AudioAlerts/DashboardAudioNotificationHelper';
import { frontendURL } from './URLHelper';
import { quoteText } from 'dashboard/routes/dashboard/team_chat/helpers/timeline';

// Who gets told about a new team chat message, per agent (ui_settings):
// every message, only @mentions (the notification bell path), or nothing.
export const TEAM_CHAT_NOTIFY_KEY = 'team_chat_notify';
export const TEAM_CHAT_NOTIFY = {
  ALL: 'all',
  MENTIONS: 'mentions',
  NONE: 'none',
};

// A busy channel must not ring on every message.
const SOUND_GAP_MS = 4000;
const SNIPPET_LENGTH = 90;
let lastSoundAt = 0;

export const teamChatNotifyPreference = store =>
  store.getters.getUISettings?.[TEAM_CHAT_NOTIFY_KEY] || TEAM_CHAT_NOTIFY.ALL;

const ringOnce = () => {
  if (Date.now() - lastSoundAt < SOUND_GAP_MS) return;
  lastSoundAt = Date.now();
  DashboardAudioNotificationHelper.playAudioAlert();
};

// Sound + toast while KALL-AI is open; a system notification when the tab is
// in the background (if the agent allowed it).
export const notifyTeamChatMessage = ({ store, router, t }, message) => {
  const userId = store.getters.getCurrentUserID;
  if (message.user_id === userId) return;
  if (teamChatNotifyPreference(store) !== TEAM_CHAT_NOTIFY.ALL) return;
  // @mentions already ring and toast through the notification path.
  if ((message.content || '').includes(`mention://user/${userId}/`)) return;

  const channel = store.getters['teamChat/getChannelById'](
    message.team_channel_id
  );
  if (!channel || channel.muted) return;
  const isReading =
    store.getters['teamChat/getActiveChannelId'] === channel.id &&
    !document.hidden;
  if (isReading) return;

  const channelName = channel.private ? channel.name : `#${channel.name}`;
  const sender = (
    message.user?.available_name ||
    message.user?.name ||
    ''
  ).split(' ')[0];
  const text =
    quoteText(message.content) ||
    (message.attachments?.length ? `📎 ${t('TEAM_CHAT.ATTACHMENT')}` : '');
  const snippet =
    text.length > SNIPPET_LENGTH ? `${text.slice(0, SNIPPET_LENGTH)}…` : text;
  const path = frontendURL(
    `accounts/${message.account_id}/team-chat/${channel.id}`
  );

  ringOnce();
  useAlert(`${channelName} · ${sender}: ${snippet}`, {
    type: 'link',
    to: path,
    message: t('TEAM_CHAT.OPEN'),
  });

  if (
    document.hidden &&
    'Notification' in window &&
    Notification.permission === 'granted'
  ) {
    const notification = new Notification(`${channelName} · ${sender}`, {
      body: snippet,
      tag: `team-chat-${channel.id}`,
    });
    notification.onclick = () => {
      window.focus();
      router.push(path);
      notification.close();
    };
  }
};
